import script from "./CallScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./CallScreen.vue?vue&type=script&setup=true&lang=js"

import "./CallScreen.vue?vue&type=style&index=0&id=262c23de&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-262c23de"]])

export default __exports__